import { Button, Card, Input, Select } from "antd";
import _ from "lodash";
import React, { useRef } from "react";

import { FilterIcon } from "../components/filterIcon";

const { Option } = Select;

/*
 * Search filter for tables
 * Compatible with both hooks and class
 */
// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function searchFilter(searchKey: any, name: any, onFilter?: any) {
  let searchInput;

  function SearchInput(props) {
    searchInput = useRef(null);

    return <Input ref={searchInput} {...props} />;
  }

  const defaultFilter = (value, record) => {
    const searchValue = _.get(record, searchKey, "");

    return searchValue.toLowerCase().includes(value.toLowerCase());
  };

  const onFilterDropdownVisibleChange = (visible) => {
    if (visible) {
      setTimeout(() => {
        searchInput.current.focus();
      });
    }
  };

  const filterIcon = (filtered) => <FilterIcon styled={{ filtered }} />;

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const filterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
    <Card
      actions={[
        <Button type="primary" onClick={confirm} key="search">
          {" "}
          Search
        </Button>,
        <Button onClick={clearFilters} key="reset">
          Reset
        </Button>,
      ]}
      size="small"
    >
      <SearchInput
        placeholder={`Search ${name}`}
        value={selectedKeys[0]}
        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={confirm}
      />
    </Card>
  );

  return {
    onFilter: onFilter || defaultFilter,
    filterIcon,
    filterDropdown,
    onFilterDropdownVisibleChange,
  };
}

/*
 * Multiple select filter for tables
 * Compatible with both hooks and class
 */
// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function multiSelectFilter(props: any) {
  const { name, dataSource = [], width } = props;
  let searchInput;

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-shadow
  function SelectInput(props) {
    searchInput = useRef(null);

    return <Select mode="multiple" ref={searchInput} optionFilterProp="children" {...props} />;
  }

  const onFilterDropdownVisibleChange = (visible) => {
    if (visible) {
      setTimeout(() => {
        searchInput.current.focus();
      });
    }
  };

  const filterIcon = (filtered) => <FilterIcon styled={{ filtered }} />;

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const filterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
    <Card
      actions={[
        <Button type="primary" onClick={confirm} key="search">
          Search
        </Button>,
        <Button onClick={clearFilters} key="reset">
          Reset
        </Button>,
      ]}
      size="small"
    >
      <SelectInput
        style={{ width: width || "200px" }}
        placeholder={`Search ${name}`}
        onChange={setSelectedKeys}
        value={selectedKeys}
      >
        {dataSource.map((data) => (
          <Option key={data._id}>{data.name}</Option>
        ))}
      </SelectInput>
    </Card>
  );

  return {
    filterIcon,
    filterDropdown,
    onFilterDropdownVisibleChange,
  };
}
